'use client'

const prepare = (acc, curr, index) => ({
  ...acc,
  [index + 1]: `${curr}rem`
});
const baseTheme = {
  colors: {
    primary700: "#26102D",
    primary600: "#4C205B",
    primary500: "#73308A",
    primary300: "#A24ABF",
    primary100: "#C186D5",
    primary50: "#E8D2EF",
    primary40: "#F9F4FB",
    secondary700: "#662A00",
    secondary600: "#994000",
    secondary500: "#DB5800",
    secondary300: "#FF8833",
    secondary100: "#FFC499",
    secondary50: "#FFF0E5",
    mineshaft700: "#333333",
    mineshaft600: "#4D4D4D",
    mineshaft500: "#666666",
    mineshaft300: "#999999",
    mineshaft100: "#CCCCCC",
    mineshaft80: "#EAEAEA",
    mineshaft50: "#F2F2F2",
    mineshaft40: "#F6F6F6",
    shiraz700: "#60061D",
    shiraz600: "#91082B",
    shiraz500: "#C10B3A",
    shiraz300: "#F43E6D",
    shiraz100: "#F9A0B6",
    shiraz50: "#FEE7ED",
    greenpea700: "#0D2618",
    greenpea600: "#194D30",
    greenpea500: "#267348",
    greenpea300: "#3FC078",
    greenpea100: "#8CD9AE",
    greenpea50: "#DCF5E7",
    white: "#FFFFFF"
  },
  breakpoints: {
    xs: "600px",
    s: "768px",
    m: "1024px",
    l: "1360px",
    xl: "1600px"
  },
  spacings: [0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5].reduce(prepare, {}),
  typography: {
    fontFamily: "Lato, Helvetica, sans-serif"
  },
  elevationStyle: {
    900: "box-shadow: 0px 18px 36px 0px rgba(51, 51, 51, 0.18);",
    600: "box-shadow: 0px 12px 24px 0px rgba(51, 51, 51, 0.18);",
    300: "box-shadow: 0px 6px 12px 0px rgba(51, 51, 51, 0.18);",
    100: "box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.18);"
  }
};

export { baseTheme };
//# sourceMappingURL=base.mjs.map
